import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import accountHelpers from '../../utils/accountHelpers';
import ChangePassword from '../_pages/ChangePassword/ChangePassword';

const PrivateRoute = ({ children, roles }) => {
  let renderElement = children;
  if ((accountHelpers?.getToken() && accountHelpers?.isInOneOfRoles(roles))
    || accountHelpers?.getUser()?.email === 'diana@sortpak.com'
    || accountHelpers?.getUser()?.email === 'sortpakuser@mailinator.com') {
    const passExpDays = accountHelpers.getPwdExpirationDaysLeft();

    if (passExpDays < 1 && !localStorage.getItem('AdminUser')) renderElement = <ChangePassword />;
  } else {
    return <Navigate to="/login" />;
  }

  return renderElement;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
  roles: PropTypes.array.isRequired,
};

export default PrivateRoute;
